<template>
  <div style="position: relative;">
    <v-img
      v-if="sectorImage"
      :src="sectorImage.url"
      :width="xs ? 60 : 80"
      :height="xs ? 60 : 80"
      :style="{ top: xs ? '6px' : '30px'}"
      style="position: absolute; right: 40px; transform: translate(50%, -50%); z-index: 99"
    />
    <t-card class="pb-3 pb-md-0" v-bind="$attrs">
      <v-toolbar
        variant="flat"
        :color="sectorColor"
        density="compact"
        height="90"
      >
        <v-toolbar-title class="card-title-responsive" :class="{ 'pr-5': !sectorImage || xs }">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="d-flex justify-space-between">
                <div class="text-caption">
                  Setor:
                </div>
              </div>
              <v-divider class="my-2" thickness="1" opacity=".9" />
              <div class="d-flex justify-space-between">
                <div :class="xs ? 'text-body-2' : 'text-body-1'">
                  {{ sector.name }}
                </div>
              </div>
            </div>
            <div v-if="!xs && sectorImage" style="width: 80px" />
          </div>
        </v-toolbar-title>
      </v-toolbar>
      <v-alert
        v-if="sectorDescription"
        icon="mdi-information-outline"
        class="mt-4 mx-4"
        variant="tonal"
        color="warning"
        dense
      >
        {{ sectorDescription }}
      </v-alert>
      <display-adapter>
        <template #mobile>
          <template v-if="listedSections.length > 1">
            <v-expansion-panels
              flat
              style="border: 1px solid #e3e3e3f3"
              :model-value="initialExpanded"
            >
              <v-expansion-panel
                v-for="section in listedSections.toSorted((a, b) => a.name.localeCompare(b.name))"
                :key="section.id"
                :disabled="section.seats?.available === 0"
              >
                <v-expansion-panel-title>
                  <div class="d-flex align-center justify-space-between w-100">
                    <span class="text-subtitle-1 text-primary font-weight-bold">
                      Seção: {{ section.name }}
                    </span>
                  </div>
                  <template v-if="section.seats?.available === 0" #actions>
                    <v-chip color="primary">
                      Indisponível
                    </v-chip>
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text class="px-0">
                  <v-card elevation="0" varianclass="grey lighten-2 mx-2 mt-4">
                    <v-card-title class="py-0 border-bottom mx-4 px-0 pt-2 mb-4">
                      <v-row class="pb-1">
                        <v-col>
                          <span class="text-caption">{{ $t("entities.type") }}:</span>
                        </v-col>
                        <v-col class="text-right">
                          <span class="text-caption">Valor Unitário:</span>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <template v-for="(ticket, index) in section.tickets.toSorted((a, b) => a.sorting_order - b.sorting_order)" :key="ticket.id">
                      <choose-ticket-card-item
                        v-model="ticket.quantidade"
                        :ticket="ticket"
                        :event="event"
                        :sector="sector"
                        :section="section"
                      />
                      <hr
                        v-if="index < section.tickets.length - 1"
                        style="border-top: dashed 1px; opacity: 0.4"
                        class="mx-4"
                      >
                    </template>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template v-else>
            <v-card elevation="0" varianclass="grey lighten-2 mx-2 mt-4">
              <v-card-title class="py-0 border-bottom mx-4 px-0 pt-2 mb-4">
                <v-row class="pb-1">
                  <v-col>
                    <span class="text-caption">{{ $t("entities.type") }}:</span>
                  </v-col>
                  <v-col class="text-right">
                    <span class="text-caption">Valor Unitário:</span>
                  </v-col>
                </v-row>
              </v-card-title>
              <template v-for="(ticket, index) in listedSections[0].tickets.toSorted((a, b) => a.sorting_order - b.sorting_order)" :key="ticket.id">
                <choose-ticket-card-item
                  v-model="ticket.quantidade"
                  :ticket="ticket"
                  :event="event"
                  :sector="sector"
                  :section="listedSections[0]"
                />
                <hr
                  v-if="index < listedSections[0].tickets.length - 1"
                  style="border-top: dashed 1px; opacity: 0.4"
                  class="mx-4"
                >
              </template>
            </v-card>
          </template>
        </template>
        <template #desktop>
          <template v-if="listedSections.length > 1">
            <v-expansion-panels
              flat
              style="border: 1px solid #e3e3e3f3"
              multiple
              :model-value="initialExpanded"
            >
              <v-expansion-panel
                v-for="(section, index) in listedSections.toSorted((a, b) => a.name.localeCompare(b.name))"
                :key="section.id"
                :disabled="section.seats?.available === 0"
                :value="index"
              >
                <v-expansion-panel-title>
                  <div class="d-flex align-center justify-space-between w-100">
                    <span class="text-subtitle-1 text-primary font-weight-bold">
                      Seção: {{ section.name }}
                    </span>
                  </div>
                  <template v-if="section.seats?.available === 0" #actions>
                    <v-chip color="primary">
                      Seção Indisponível
                    </v-chip>
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text class="px-0">
                  <v-table class="transparent">
                    <thead>
                      <tr>
                        <th class="table-header">
                          {{ $t("entities.type") }}
                        </th>
                        <th v-if="!settings.match(event, 'HIDE_BATCH_NUMBER')" class="text-center table-header">
                          Lote
                        </th>
                        <th class="text-center table-header">
                          Valor Unitário
                        </th>
                        <th class="text-center table-header">
                          Taxa de Serviço
                        </th>
                        <th class="text-center table-header">
                          Quantidade
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <choose-ticket-card-item
                        v-for="ticket in section.tickets.toSorted((a, b) => a.sorting_order - b.sorting_order)"
                        :key="ticket.id"
                        v-model="ticket.quantidade"
                        :event="event"
                        :sector="sector"
                        :section="section"
                        :ticket="ticket"
                      />
                    </tbody>
                  </v-table>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template v-else>
            <v-table class="transparent">
              <thead>
                <tr>
                  <th class="table-header">
                    {{ $t("entities.type") }}
                  </th>
                  <th v-if="!settings.match(event, 'HIDE_BATCH_NUMBER')" class="text-center table-header">
                    Lote
                  </th>
                  <th class="text-center table-header">
                    Valor Unitário
                  </th>
                  <th class="text-center table-header">
                    Taxa de Serviço
                  </th>
                  <th class="text-center table-header">
                    Quantidade
                  </th>
                </tr>
              </thead>
              <tbody>
                <choose-ticket-card-item
                  v-for="ticket in listedSections[0].tickets.toSorted((a, b) => a.sorting_order - b.sorting_order)"
                  :key="ticket.id"
                  v-model="ticket.quantidade"
                  :event="event"
                  :sector="sector"
                  :section="listedSections[0]"
                  :ticket="ticket"
                />
              </tbody>
            </v-table>
          </template>
        </template>
      </display-adapter>
    </t-card>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import ChooseTicketCardItem from "./ChooseTicketCardItem.vue";
import TCard from "@/components/core/TCard.vue";
import type Section from "@/types/Section";
import type Event from "@/types/Event";
import type Sector from "@/types/Sector";
import DisplayAdapter from "@/components/core/DisplayAdapter.vue";
import { useDisplay } from "vuetify";
import { useSettings } from "@/plugins/settings.js";

interface Props {
  sector: Sector;
  modelValue?: Section[];
  event: Event;
}

type Emits = (e: "update:modelValue", value: Section[]) => void;

const { xs } = useDisplay();
const settings = useSettings();

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
});

const emit = defineEmits<Emits>();

const sections = computed<Section[]>({
  get(): Section[] {
    return props.modelValue;
  },
  set(value: Section[]) {
    emit("update:modelValue", value);
  },
});

/** Sections with no ticket type left render nothing. */
const listedSections = computed<Section[]>(() => sections.value.filter(section => section.tickets.length > 0));

const initialExpanded = ref(0);

// Per event sector configs
const sectorConfigs = computed(() => {
  return props.event.sector_configs.find(c => c.sector_id === props.sector.id);
});

const sectorColor = computed(() => sectorConfigs.value?.color ?? "primary");

const sectorDescription = computed(() => sectorConfigs.value?.description);

const sectorImage = computed(() => {
  return props.event.images?.find(i => i.id === sectorConfigs.value?.shield_image_id);
});

onMounted(() => {
  let i = 0;
  for (const section of listedSections.value.toSorted((a, b) => a.name.localeCompare(b.name))) {
    if (section.seats === undefined) {
      i++;
      continue;
    }

    if (section.seats?.available !== 0) {
      initialExpanded.value = i;
      break;
    }
    i++;
  }
});

defineOptions({
  name: "ChooseTicket",
  inheritAttrs: false,
});
</script>

<style>
button.v-expansion-panel-title {
  padding-left: 18px !important;
}

.v-expansion-panel-text__wrapper {
  padding: 0 !important;
}

.table-header {
  font-size: 1rem !important;
}

.border-bottom {
  border-bottom: 1px solid #bbb;
}
</style>

<style scoped>
:deep(.v-toolbar-title__placeholder) {
  white-space: normal;
  overflow: visible;
}
</style>
